import { useRef } from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import { cn } from '@/shared/lib/utils';
import { Image } from '@/shared/ui/img/Image';
import TransparentArrowButton from '@/shared/ui/buttons/TransparentArrowButton';

export interface IPlanSliderProps {
    images: Array<string>;
    className?: string;
}

export function PlanSlider({ images, className }: IPlanSliderProps) {


    const swiperRef = useRef<SwiperType | null>(null);

    const handleSwiperNext = () => {
        if (swiperRef.current) swiperRef.current.slideNext()
    }

    const handleSwiperPrev = () => {
        if (swiperRef.current) swiperRef.current.slidePrev()
    }

    return (
        <div className={cn('min-w-[355px] md:min-w-[412px] overflow-hidden relative', className)} >

            <TransparentArrowButton
                className="absolute z-10 left-[0px] top-1/2 -translate-y-1/2"
                arrow='left'
                onClick={handleSwiperPrev}
            />

            <TransparentArrowButton
                className="absolute z-10 right-[0px] top-1/2 -translate-y-1/2"
                arrow='right'
                onClick={handleSwiperNext}
            />

            <Swiper
                direction="horizontal"
                loop={true}
                modules={[]}
                slidesPerView='auto'
                pagination={{ clickable: true }}
                className="mySwiper h-auto"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {
                    images.map((item, index) => {
                        return (
                            <SwiperSlide key={index} className='px-[48px] md:px-[56px]'>
                                <Image
                                    fallbackSrc='/images/defaults/schema.png'
                                    className='w-full h-full object-contain'
                                    src={item? item: '/images/defaults/schema.png'}
                                    alt=''
                                />
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </div>

    )
   
}
